import { SLViewerComponent } from './../../app-selector/configs/sl-viewer/sl-viewer.component';
import { MapComponent } from 'src/app/components/map/map.component';
import { ActionGroupComponent } from 'src/app/components/action-group/action-group.component';

import { EditorAction } from './editor-action';
import { ISLMap } from 'src/app/types/@types/sl-map';

import { LayersViewComponent } from 'src/app/components/layers-view/layers-view.component';
import { LayerAttributesViewComponent } from 'src/app/components/layer-attributes-view/layer-attributes-view.component';
import { LayerAttributeViewComponent } from 'src/app/components/layer-attribute-view/layer-attribute-view.component';
import { LayerViewComponent } from 'src/app/components/layer-view/layer-view.component';
import { SLLayer } from '../sl-layer';
import { ViewStackViewComponent } from 'src/app/components/view-stack/view-stack-view/view-stack-view.component';
import { ActionMap } from 'src/app/services/action-handler.service';
import { SLContext } from 'src/app/types/sl-context';
import { InfoAction } from './info-action';

export class MapDataAction {
  public static Exec(command: string, map: MapComponent, args?: any) {
    const mapDataGroup: ActionGroupComponent | null = map.SLMap.src.GetActionGroup('Map Data');
    const infoGroup: ActionGroupComponent | null = map.SLMap.src.GetActionGroup('Info Modes');
    switch (command) {
      case 'layers-toggle':
        map.SLMap.src.panelSet.OpenPrimary();
        map.SLMap.src.ToggleLayers();
        if (!!map.SLMap.src.hasKeyActions) return;
        map.SLMap.src.SetDataView('layers', args.selected === true);

        if (mapDataGroup !== null) {
          mapDataGroup.SetSelected('Data layers', args.selected === true);
        }
        if (infoGroup !== null) {
          infoGroup.SetSelected('Search', false);
        }
        break;
      case 'search-toggle':
        map.SLMap.src.ToggleSearch();
        map.SLMap.src.panelSet.OpenPrimary();
        if (!!map.SLMap.src.hasKeyActions) return;
        map.SLMap.src.SetDataView('search', args.selected === true);

        if (mapDataGroup !== null) {
          mapDataGroup.SetSelected('Search', args.selected === true);
        }
        if (infoGroup !== null) {
          infoGroup.SetSelected('Search', args.selected === true);
        }
        map.SLMap.src.panelSet.OpenPrimary();
        break;
      case 'legend-toggle':
        if (map.SLMap.src.secondaryViews.currentView.viewName === 'attribute') {
          InfoAction.Exec('query-mode-toggle', map, {});
        }
        map.SLMap.src.ToggleLegend();
        map.SLMap.src.secondaryViews


        map.SLMap.src.SetSecondaryView('legend', args.selected === true);
        mapDataGroup.SetSelected('Legend', args.selected === true);
        if (!!map.SLMap.src.hasKeyActions) return;

        if (args.selected === true) {
          map.SLMap.src.panelSet.OpenSecondary();
        }
        break;
      case 'legend-reload':
        MapDataAction.LegendReload(map, {});
        break;
      case 'editor-toggle':
        // const isExpanded = map.SLMap.src.ToggleEditorView();
        map.SLMap.src.SetSecondaryView('attribute', args.selected === true);
        if (map.SLMap.src.secondaryViews.currentView.IsActive() && (args.selected === true)) {
          EditorAction.ShowEditor(map, { edit: 'geom' });
        }
        if (args.selected === true) {
          map.SLMap.src.panelSet.OpenSecondary();
        }
        break;
      case 'image-capture':
        map.SLMap.src.SetSecondaryView('imageCapture', args.selected === true);
        if (map.SLMap.src.secondaryViews.currentView.IsActive && (args.selected === true)) {
          map.SLMap.src.imageCaptureView.Capture(map.SLMap);
          if (args.selected === true) {
            map.SLMap.src.panelSet.OpenSecondary();
          }
        }

        break;
      case 'image-capture-select':
        const actionGroup: ActionGroupComponent = map.SLMap.src.GetActionGroup('Map Data');
        actionGroup.SetSelected('Capture map image', true);
        map.SLMap.src.SetSecondaryView('imageCapture', true);

        map.SLMap.src.imageCaptureView.Capture(map.SLMap);
        break;


    }
    map.SLMap.src.panelSet.UpdatePanels();

  }
  public static RegisterActions(actions): ActionMap {
    actions['map data/image-capture'] = {
      name: 'Show image capture tool',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          MapDataAction.Exec('image-capture', context.map.component, { selected: true });
        }
      },
      keys: {
        key: 'c'
      },
      trigger: 'press'
    }
    actions['map data/layers-toggle'] = {
      name: 'Toggle layers list',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          MapDataAction.Exec('layers-toggle', context.map.component, { selected: true });
          if (!!context.map.src.hasKeyActions) return;


        }
      },
      keys: {
        key: 'l',
        shift: true
      },
      trigger: 'press'
    }
    actions['map data/search-toggle'] = {
      name: 'Toggle search/find tool',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          MapDataAction.Exec('search-toggle', context.map.component, { selected: true });
        }
      },
      keys: {
        key: 'f',
        ctrl: true
      },
      trigger: 'press'
    }
    actions['map data/legend-toggle'] = {
      name: 'Toggle legend tool',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          MapDataAction.Exec('legend-toggle', context.map.component, { selected: true });

        }
      },
      keys: {
        shift: true,
        key: 'l'
      },
      trigger: 'press'
    }
    /*actions['map data/editor-toggle'] = {
      name: 'Show digitizer (editor) tool',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          EditorAction.Exec('show', context.map.component, { selected: true });
        }
      },
      keys: {
        ctrl: true,
        key: 'd',
      },
      trigger: 'press'
    }*/
    actions['result-history/show'] = {
      name: 'Show results gallery',
      handler: (context: SLContext, ..._args: any) => {
        context.OpenGallery();
      },
      keys: {
        ctrl: true,
        shift: true,
        key: 'r'
      },
      trigger: 'press'
    }
    actions['map data/show-results-list'] = {
      name: 'Show results list',
      handler: (context: SLContext, ..._args: any) => {
        context.map.ShowResultsView();
      },
      keys: {
        ctrl: true,
        key: 'r'
      },
      trigger: 'press'
    }
    actions['map data/show-info'] = {
      name: 'Show info panel',
      handler: (context: SLContext, ..._args: any) => {
        context.map.ShowInfo()
        context.map.OpenSecondary();
        if (!!(context as any).infoView) {
          (context as any).infoView.Expand();
        }
      },
      keys: {
        ctrl: true,
        shift: true,
        key: 'i'
      },
      trigger: 'press'
    },
      actions['map data/legend-reload'] = {
        name: 'Reload Legend',
        handler: (context: SLContext, ..._args: any) => {
          MapDataAction.LegendReload(context.map.component, _args);
        },
        keys: {
          ctrl: true,
          shift: true,
          key: 'l'
        },
        trigger: 'press'
      },
      actions['map data/focus-map'] = {
        name: 'Set focus on map area',
        handler: (context: SLContext, ..._args: any) => {
          context.map.component.SetFocus();
         
        },
        keys: {
          key: 'm'
        },
        trigger: 'press'
      }



    return actions;
  }
  public static UpdateLayerPropertyView(layer: SLLayer) {
    if (!layer.SLMap.src.layerView) {
      return;
    }
    if (!layer.SLMap.src.primaryViews) {
      return;
    }
    if (layer.IsVirtual() === false) {
      return;
    }
    if (layer.SLMap.src.primaryViews.currentView.viewName === 'layer') {

      const layers: LayersViewComponent = (layer.SLMap.src.layersView as LayersViewComponent);
      const node = layers.GetNode(layer.identifier);
      (layer.SLMap.src.layerView as LayerViewComponent).UpdateLayer(layer, node, layers)
    }
  }
  public static CloseCapture(map: MapComponent, data: any) {
    const actionGroup: ActionGroupComponent = map.SLMap.src.GetActionGroup('Map Data');
    actionGroup.SetSelected('Capture map image', false);
    map.SLMap.src.SetSecondaryView('imageCapture', false);
    map.SLMap.src.panelSet.UpdatePanels();

  }
  public static LegendReload(map: MapComponent, _data: any) {
    if (!!map.SLMap.src.legendView) {
      map.SLMap.src.legendView.ShowLegend(map.SLMap.layers, false);

    }
  }
  public static UpdateSearchables(layer: SLLayer) {
    if (!layer.SLMap.src.layerView) {
      return;
    }
    if (!layer.SLMap.src.primaryViews) {
      return;
    }
    if (layer.IsVirtual() === true) {
      return;
    }
    (layer.SLMap.src as SLViewerComponent).searchView.UpdateSearchables();

  }
  public static SetupButtons(map: MapComponent) {

  }
}
